export default __webpack_public_path__ + "static/media/space_tracker_64.vst.267eb396.dll";